<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="prioridades"
                    label="Prioridade"
                    text-field="nome"
                    v-model="model.prioridadeId"
                    :validations="validations.prioridadeId"
                    value-field="id"
                >
                    <rkm-form-select-option
                        :value="null"
                        slot="first"
                    >
                        Selecione
                    </rkm-form-select-option>
                </rkm-form-select>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

// Utils.
import senha from '@/utils/painel-senha/impressao/senha'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            lotacao: 'getLotacao',
        }),
        validations() {
            return {
                prioridadeId: {
                    required: this.opcaoEntrada.prioridadeObrigatoria
                }
            }
        }
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('painelSenha.fila')
        }
    },
    data: () => ({
        model: {
            prioridadeId: null
        },
        utils: { senha },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    const request = {
                        centro_custo_id: this.centroCusto.id,
                        opcao_entrada_id: this.opcaoEntrada.id,
                        prioridade_id: this.model.prioridadeId,
                    }

                    this.setLoading()

                    this.repositories.fila.store(request)
                        .then(response => {
                             const params = {
                                infraestrutura: this.lotacao.infraestrutura.nome,
                                setor: this.centroCusto.setor.nome,
                                senha: response.data.senha,
                                data: response.data.dataEmissao,
                                hora: response.data.horaEmissao,
                                cliente: this.cliente.nome,
                            }

                            this.utils.senha.print(params)
                            this.$emit('save', response)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [ error, repository ],
    props: {
        centroCusto: { type: Object, required: true },
        opcaoEntrada: { type: Object, required: true },
        prioridades: { type: Array, required: true },
    }
}
</script>